import { render, staticRenderFns } from "./UserUtilizadoresAtivos.vue?vue&type=template&id=2ec5fbb7&"
import script from "./UserUtilizadoresAtivos.vue?vue&type=script&lang=js&"
export * from "./UserUtilizadoresAtivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports